import React, { useEffect, useState } from "react";
import { Badge, Spinner, Modal, Table } from "react-bootstrap";
import { FiArrowRight, FiPackage, FiTruck, FiUser, FiInfo, FiActivity } from "react-icons/fi";
import logo from "../images/TP-_logo-orizz-claim-color.png";
import "bootstrap/dist/css/bootstrap.min.css";

const WidgetCrossDocking = () => {
  const [datiRaw, setDatiRaw] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);

  useEffect(() => {
    fetch("./ordini_urgenti.json")
      .then((res) => res.json())
      .then((data) => {
        const lista = data?.CROSS_DOCKING?.flat() || [];
        setDatiRaw(lista);
        setLoading(false);
      })
      .catch((err) => {
        console.error("Errore Cross Docking:", err);
        setLoading(false);
      });
  }, []);

  const testate = datiRaw.filter((item) => item.Is_Totale === "1");

  const handleOpenDettaglio = (ordine) => {
    const articoli = datiRaw.filter(
      (d) =>
        d.Is_Totale === "0" &&
        d.Doc_Cliente === ordine.Doc_Cliente &&
        d.Doc_Fornitore === ordine.Doc_Fornitore,
    );
    setSelectedOrder({ ...ordine, articoli });
    setShowModal(true);
  };

  return (
    <div className="shadow-lg card tb" style={{
        borderRadius: "16px", border: "1px solid #333", height: "100%",
        display: "flex", flexDirection: "column", background: "#121212", overflow: "hidden"
    }}>
      {/* Header Widget - Dark & Red */}
      <div className="p-3 border-bottom d-flex justify-content-between align-items-center" style={{ background: "#1a1a1a", borderColor: "#333" }}>
        <span style={{ fontWeight: "800", fontSize: "0.75rem", color: "#b81f25", letterSpacing: "1.5px" }}>
            <FiActivity className="me-2"/> CROSS-DOCKING LIVE
        </span>
        <Badge bg="danger" className="rounded-pill" style={{ fontSize: '0.6rem', backgroundColor: '#b81f25' }}>
          {testate.length} ATTIVI
        </Badge>
      </div>

      <style>{`
        .scroll-area-cd { overflow-y: auto; flex-grow: 1; padding: 15px; }
        .scroll-area-cd::-webkit-scrollbar { width: 4px; }
        .scroll-area-cd::-webkit-scrollbar-thumb { background: #444; border-radius: 10px; }
        
        .cd-card { 
            background: #1e1e1e; border: 1px solid #333; border-radius: 12px; 
            margin-bottom: 15px; padding: 18px; cursor: pointer; 
            transition: all 0.3s ease; position: relative;
        }
        .cd-card:hover { 
            border-color: #b81f25; background: #252525;
            box-shadow: 0 8px 25px rgba(184, 31, 37, 0.15) !important; 
        }
        .cd-card::before {
            content: ''; position: absolute; left: 0; top: 15%; height: 70%; width: 3px;
            background: #b81f25; border-radius: 0 4px 4px 0;
        }

        .flow-line { display: flex; align-items: center; justify-content: space-between; gap: 10px; }
        .node { flex: 1; min-width: 0; }
        .node-label { font-size: 0.6rem; color: #666; font-weight: 800; text-transform: uppercase; margin-bottom: 4px; }
        .node-doc { font-size: 0.85rem; font-weight: 700; color: #b81f25; font-family: 'Monaco', monospace; }
        .node-name { font-size: 0.75rem; color: #ccc; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
        
        .arrow-box { display: flex; flex-direction: column; align-items: center; color: #b81f25; min-width: 70px; }
        .arrow-icon { animation: slideRight 2s infinite; font-size: 1.1rem; margin-top: 5px; }
        
        @keyframes slideRight {
            0% { transform: translateX(-4px); opacity: 0.4; }
            50% { transform: translateX(4px); opacity: 1; }
            100% { transform: translateX(-4px); opacity: 0.4; }
        }

        /* Modal Dark Overrides */
        .modal-dark-custom .modal-content { background: #161616; border: 1px solid #333; border-radius: 16px; color: #fff; }
        .modal-dark-custom .modal-header { border-bottom: 1px solid #333; }
        .modal-dark-custom .table { color: #eee; }
        .info-strip { background: #222; border: 1px solid #333; }
      `}</style>

      <div className="scroll-area-cd">
        {loading ? (
          <div className="text-center py-5"><Spinner animation="border" variant="danger" /></div>
        ) : (
          testate.map((item, idx) => (
            <div key={idx} className="cd-card shadow-lg" onClick={() => handleOpenDettaglio(item)}>
              <div className="flow-line">
                <div className="node text-start">
                  <div className="node-label"><FiTruck className="me-1"/> Provenienza</div>
                  <div className="node-doc">{item.Doc_Fornitore}</div>
                  <div className="node-name">{item.Fornitore}</div>
                </div>

                <div className="arrow-box">
                  <Badge bg="transparent" className="border border-danger text-danger" style={{ fontSize: '0.55rem' }}>
                    {item.Conteggio} RIGHE
                  </Badge>
                  <FiArrowRight className="arrow-icon" />
                </div>

                <div className="node text-end">
                  <div className="node-label"><FiUser className="me-1"/> Destinatario</div>
                  <div className="node-doc text-light">{item.Doc_Cliente}</div>
                  <div className="node-name">{item.Cliente}</div>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* MODALE DETTAGLIO - DARK MODE */}
      <Modal show={showModal} onHide={() => setShowModal(false)} centered size="lg" className="modal-dark-custom">
        <Modal.Header closeButton closeVariant="white">
          <Modal.Title className="fw-bold d-flex align-items-center" style={{ fontSize: '0.9rem', color: '#b81f25' }}>
            <FiPackage className="me-2"/> ANALISI FLUSSO LOGISTICO
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="info-strip rounded-3 p-3 mb-4 d-flex justify-content-between align-items-center">
            <div style={{ flex: 1 }}>
              <small className="text-muted d-block" style={{ fontSize: '0.6rem' }}>FORNITORE</small>
              <span className="fw-bold text-light" style={{ fontSize: '0.8rem' }}>{selectedOrder?.Fornitore}</span>
            </div>
            <div className="px-3 text-danger"><FiArrowRight size={20}/></div>
            <div style={{ flex: 1 }} className="text-end">
              <small className="text-muted d-block" style={{ fontSize: '0.6rem' }}>CLIENTE</small>
              <span className="fw-bold text-light" style={{ fontSize: '0.8rem' }}>{selectedOrder?.Cliente}</span>
            </div>
          </div>

          <Table responsive borderless className="mb-0">
            <thead>
              <tr style={{ borderBottom: '1px solid #333' }}>
                <th className="text-muted pb-3" style={{ fontSize: '0.65rem' }}>ARTICOLO</th>
                <th className="text-center text-muted pb-3" style={{ fontSize: '0.65rem' }}>QUANTITÀ</th>
                <th className="text-end text-muted pb-3" style={{ fontSize: '0.65rem' }}>STATO</th>
              </tr>
            </thead>
            <tbody>
              {selectedOrder?.articoli.map((art, i) => (
                <tr key={i} style={{ borderBottom: '1px solid #222' }}>
                  <td className="py-3">
                    <div className="fw-bold text-light" style={{ fontSize: '0.85rem' }}>{art.articolo}</div>
                    <div className="text-muted" style={{ fontSize: '0.7rem' }}>Cod: {art.precodice || "N/A"}</div>
                  </td>
                  <td className="text-center py-3">
                    <Badge bg="danger" style={{ backgroundColor: '#b81f25', padding: '6px 12px' }}>{art.Conteggio}</Badge>
                  </td>
                  <td className="text-end py-3">
                    <span className="text-success" style={{ fontSize: '0.7rem', fontWeight: '700' }}>● PRONTO</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
        </Modal.Body>
        <Modal.Footer className="border-0">
          <img src={logo} alt="Logo" style={{ width: "120px", filter: "brightness(0) invert(1)", opacity: 0.5 }} />
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default WidgetCrossDocking;